import type { CreateRecordActionConfigure, FlowNodeResultADT, SettingRecordFields } from '@lighthouse/shared'
import { type ActionFlowNode, type CreateRecordActionConfig, getCreateRecordVariableValue, pageStackPubSub } from '@lighthouse/shared'
import { t } from 'i18next'

import * as srv from '@/services'

import type { ExecuteActionParams } from '../type'

export const handleCreateRecordStream = async (
    node: ActionFlowNode<CreateRecordActionConfigure>,
    params: ExecuteActionParams
): Promise<undefined | FlowNodeResultADT> => {
    const {
        data: { config }
    } = node

    if (!config) {
        throw new Error(t('configurationNotPerfect'))
    }

    const record = await handleCreateRecord(config, params)

    if (!record.id) {
        throw new Error(t('createRecordError'))
    }

    return {
        type: 'record',
        success: !!record.id,
        data: record
    }
}

export const handleCreateRecord = async (config: SettingRecordFields, params: ExecuteActionParams) => {
    const { appId, envId, actionEvents } = params
    const { dataSourceId, fields } = config

    const fieldsValue = getCreateRecordVariableValue({ dataSourceId, fields }, params)
    const record = await srv.createRecordWithFields({
        appId,
        envId,
        dsId: dataSourceId,
        fields: fieldsValue
    })

    if (record.id) {
        actionEvents.createRecord(record)
        // 更新行以后，需要通知对应订阅更新数据
        pageStackPubSub.emit(`${dataSourceId}-ADD`, record)
    }

    return record
}
